import AUTH_ROUTES from "./auth-views/routes";
import APP_ROUTES from "./app-views/routes";
const ROUTES = [...AUTH_ROUTES, ...APP_ROUTES];

export default ROUTES;
